import React from "react";
import { Tooltip, Box, Typography, Stack, Divider } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface Props {
  squareFootage: number;
  children: React.ReactElement;
}

const SQ_MI_TO_SQ_FT = 27878400;

const REFERENCES = [
  { name: "France", areaSqMi: 212344 },
  { name: "Sweden", areaSqMi: 173860 },
  { name: "California", areaSqMi: 163695 },
  { name: "Norway", areaSqMi: 148726 },
];

const MapReferenceCompareTooltip = ({ squareFootage, children }: Props) => {
  const areaSqMi = squareFootage / SQ_MI_TO_SQ_FT;

  const renderComparison = () => (
    <Box sx={{ p: 1 }}>
      <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
        Area Comparisons
      </Typography>
      <Divider sx={{ mb: 1, bgcolor: "rgba(255,255,255,0.2)" }} />
      <Stack spacing={0.5}>
        {REFERENCES.map((ref) => {
          const ratio = (areaSqMi / ref.areaSqMi) * 100;
          let comparisonText = "";
          
          if (ratio >= 1) {
            comparisonText = `${(areaSqMi / ref.areaSqMi).toFixed(1)}x the size of ${ref.name}`;
          } else {
            comparisonText = `${ratio.toFixed(2)}% of ${ref.name}`;
          }

          return (
            <Typography key={ref.name} variant="caption" sx={{ display: "block" }}>
              • {comparisonText}
            </Typography>
          );
        })}
      </Stack>
    </Box>
  );

  return (
    <Tooltip 
      title={renderComparison()} 
      arrow 
      placement="top"
      enterTouchDelay={0}
      leaveTouchDelay={3000}
    >
      <Box sx={{ display: "flex", alignItems: "center", cursor: "help" }}>
        {children}
        <InfoOutlinedIcon sx={{ ml: 0.5, fontSize: "0.85rem", opacity: 0.7 }} />
      </Box>
    </Tooltip>
  );
};

export default MapReferenceCompareTooltip;
